/*
 * Copyright (c) 2017 Datarista, Inc.
 */

import { Record, fromJS } from 'immutable';
import { actionTypes } from '../actions/authentication';
import { storeWithExpiration } from '../utils/common';

const Authentication = new Record(
  {
    token: storeWithExpiration.get('token'),
    isFetching: false,
    isAuthenticated: !storeWithExpiration.get('token') === undefined,
    error: null,
  },
  'Authentication'
);

const initialState = new Authentication();

export const _createAuthentication = data => new Authentication(fromJS(data));

export default function reducer(state = initialState, action) {
  const auth = {
    token: action.token,
    isFetching: action.isFetching,
    isAuthenticated: action.isAuthenticated,
    error: null,
  };
  switch (action.type) {
    case actionTypes.AUTH_LOGIN_REQUEST:
    case actionTypes.AUTH_LOGIN_SUCCESS:
    case actionTypes.AUTH_LOGOUT_REQUEST:
    case actionTypes.AUTH_LOGOUT_SUCCESS:
    case actionTypes.AUTH_REFRESH_REQUEST:
    case actionTypes.AUTH_REFRESH_SUCCESS:
    case actionTypes.AUTH_CHECK_REQUEST:
    case actionTypes.AUTH_CHECK_SUCCESS: {
      return _createAuthentication(auth);
    }
    case actionTypes.AUTH_LOGIN_ERROR: {
      const error = {
        token: null,
        isFetching: false,
        isAuthenticated: false,
        error: action.error,
      };
      return _createAuthentication(error);
    }
    default: {
      return state;
    }
  }
}
